export const RouteConstants = {
  ASSESSMENT_ROOT: '/assessment',
  ASSESSMENT_HOME: '/assessment/home',
  ASSESSMENT_SURVEY: '/assessment/survey',
  ASSESSMENT_RESULT: '/assessment/result',
  ASSESSMENT_FINISH: '/assessment/finish',
};
